var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrushSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.745 11.3253C37.17 15.2403 33.6 20.3553 30.18 23.7003C29.685 20.6103 27.225 18.1953 24.105 17.7603C27.465 14.3403 32.61 10.7103 36.54 9.12033C37.23 8.85033 37.935 9.06033 38.355 9.49533C38.82 9.94533 39.03 10.6353 38.745 11.3253Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.18 23.6861C29.58 24.2711 28.98 24.8111 28.41 25.2611L26.055 27.1511C25.755 27.3611 25.455 27.5411 25.125 27.6911C25.125 27.4661 25.095 27.2411 25.08 27.0011C24.945 26.0111 24.495 25.0661 23.685 24.2561C22.86 23.4461 21.87 22.9811 20.865 22.8461C20.625 22.8161 20.37 22.8161 20.145 22.8161C20.28 22.4411 20.475 22.0961 20.73 21.8111L22.605 19.4561C23.055 18.8861 23.565 18.3161 24.12 17.7461C27.225 18.1811 29.7 20.6111 30.18 23.6861Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1249 27.7057C25.1249 29.0257 24.6149 30.2857 23.6699 31.2307C22.9349 31.9657 21.9599 32.4757 20.7599 32.6257L17.8199 32.9557C16.2149 33.1357 14.8349 31.7557 15.0149 30.1357L15.3449 27.1957C15.6299 24.5707 17.8199 22.8907 20.1449 22.8457C20.3699 22.8307 20.6249 22.8457 20.8649 22.8757C21.8849 23.0107 22.8599 23.4757 23.6849 24.2857C24.4799 25.0807 24.9449 26.0407 25.0799 27.0307C25.0949 27.2557 25.1249 27.4807 25.1249 27.7057Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushSquare);
export default __webpack_public_path__ + "static/media/brushSquare.b6809949256c1e3fb6482ad3ac4d8596.svg";
export { ForwardRef as ReactComponent };